import React from 'react';
import * as PropTypes from 'prop-types';
import { Container } from 'react-bootstrap';
export var HOSupplementSection = function (_a) {
    var className = _a.className, color = _a.color;
    var classnames = className || '';
    return (React.createElement(Container, { style: { height: 0 } },
        React.createElement("div", { className: "supplement-section color-" + color + " " + classnames })));
};
HOSupplementSection.propTypes = {
    color: PropTypes.string.isRequired
};
